export const brand = 'iLingu Languages';